"use client";

import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M19 7h-8v6h8zm4-4H1v17.98h22zm-2 16.01H3V4.98h18z"
}), 'PictureInPictureSharp');